import Vue from 'vue'
import Router from 'vue-router'

import City from './views/City'
import Intro from './views/Intro'
import District from './views/District'
import Auditorium from './views/Auditorium'
import Avatar from './views/Avatar'
import Account from './views/Account'
import Login from './views/Login'
import Create from './views/Create'
import SignIn from './views/SignIn'
import Reset from './views/Reset'

import messages from './locales'

Vue.use(Router)

const routes = [
  {
    path: '/city',
    name: 'city',
    component: City,
    props: {
      isMap: false
    },
    meta: {
      isMainScene: true,
      isMenu: true,
      needsCredential: true,
      cameraBase: false
    }
  },
  {
    path: '/map',
    name: 'map',
    component: City,
    props: {
      isMap: true
    },
    meta: {
      isMainScene: true,
      isMenu: true,
      needsCredential: true,
      cameraBase: false
    }
  },
  {
    path: '/',
    name: 'intro',
    component: Intro,
    meta: {
      isMainScene: true,
      isMenu: false,
      needsCredential: true,
      cameraBase: true
    }
  },
  {
    path: '/avatar',
    name: 'avatar',
    component: Avatar,
    meta: {
      isMainScene: false,
      isMenu: false,
      needsCredential: true,
      cameraBase: false
    }
  },
  {
    path: '/account',
    name: 'account',
    component: Account,
    meta: {
      isMainScene: true,
      isMenu: false,
      needsCredential: true,
      cameraBase: true
    }
  },
  {
    path: '/district/:slug',
    name: 'district',
    component: District,
    meta: {
      isMainScene: true,
      isMenu: true,
      needsCredential: true,
      cameraBase: false
    }
  },
  {
    path: '/district/:slug/:id',
    name: 'keypoint',
    component: District,
    meta: {
      isMainScene: true,
      isMenu: true,
      needsCredential: true,
      cameraBase: false
    }
  },
  {
    path: '/district/:slug/:id/:articleSlug',
    name: 'article',
    component: District,
    meta: {
      isMainScene: true,
      isMenu: true,
      needsCredential: true,
      cameraBase: false
    }
  },
  {
    path: '/auditorium',
    name: 'auditorium',
    component: Auditorium,
    meta: {
      isMainScene: true,
      isMenu: true,
      needsCredential: true,
      cameraBase: false
    }
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      isMainScene: true,
      isMenu: false,
      needsCredential: false,
      cameraBase: true
    }
  },
  {
    path: '/create',
    name: 'create',
    component: Create,
    meta: {
      isMainScene: true,
      isMenu: false,
      needsCredential: false,
      cameraBase: true
    }
  },
  {
    path: '/sign-in',
    name: 'signin',
    component: SignIn,
    meta: {
      isMainScene: true,
      isMenu: false,
      needsCredential: false,
      cameraBase: true
    }
  },
  {
    path: '/reset',
    name: 'reset',
    component: Reset,
    meta: {
      isMainScene: true,
      isMenu: false,
      needsCredential: false,
      cameraBase: true
    }
  },
  {
    path: '*',
    redirect: '/'
  }
]

let langRoutes = []

for (let i = 0; i < routes.length; i++)  {
  for (const locale of Object.keys(messages)) {
    const prefix = locale === 'en' ? '' : '/' + locale + ''
    let route = {...routes[i]}
    route.path = prefix + route.path
    route.name = locale + '/' + route.name
    route.meta = {
      ...routes[i].meta,
      locale: locale
    }

    langRoutes.push(route)
  }
}

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL || '/',
  routes: langRoutes
})
